var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.board && _vm.board.boardSkin === 'default')?_c('BoardDefaultDetail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"post":_vm.post,"board":_vm.board}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }